(function skillsApiServiceIIFE() {
    'use strict';

    angular
        .module('hrpro')
        .service('SkillsApi', SkillsApi);

    /**
     * Provides an ability to interact with the skills related endpoints of the API
     */
    function SkillsApi(ApiHelper, $http) {
        this.getList = getList;
        this.getModel = getModel;
        this.save = save;

        function getList(context) {
            var config = {
                method: 'get',
                url: ApiHelper.buildUrl('technology'),
                context: context
            };
            return $http(config);
        }

        function getModel() {
            var model = {
                name: null,
                weight: 0
            };
            return model;
        }

        function save(model, context) {
            var config = {
                method: 'post',
                url: ApiHelper.buildUrl('technology'),
                data: model,
                context: context
            };
            return $http(config);
        }
    }
})();
